import { Card, CardBody, Col, Row } from "reactstrap"
import { Link } from "react-router-dom"
import { ACCESS } from "constants/accessPermissions"
import { CanView } from "components/Common/CanView"

const setupLinks = [
  { label: "Accounts", path: "/account-list", access: [ACCESS.ACCOUNT.VIEW_LIST], icon: "mdi mdi-bank-outline" },
  { label: "Vendors", path: "/account-vendor-list", access: [ACCESS.ACCOUNT_VENDOR.VIEW_LIST], icon: "mdi mdi-store-outline" },
  { label: "Payment Methods", path: "/account-payment-method-list", access: [ACCESS.ACCOUNT_PAYMENT_METHOD.VIEW_LIST], icon: "mdi mdi-credit-card-outline" },
  { label: "Account Types", path: "/account-account-type-list", access: [ACCESS.ACCOUNT_ACCOUNT_TYPE.VIEW_LIST], icon: "mdi mdi-shape-outline" },
  { label: "Transaction Types", path: "/account-transaction-type-list", access: [ACCESS.ACCOUNT_TRANSACTION_TYPE.VIEW_LIST], icon: "mdi mdi-swap-horizontal" },
  { label: "Expense Types", path: "/account-expense-type-list", access: [ACCESS.ACCOUNT_EXPENSE_TYPE.VIEW_LIST], icon: "mdi mdi-tag-outline" },
  { label: "Loan Statuses", path: "/account-loan-status-list", access: [ACCESS.ACCOUNT_LOAN_STATUS.VIEW_LIST], icon: "mdi mdi-flag-outline" },
  { label: "Bill Statuses", path: "/account-bill-status-list", access: [ACCESS.ACCOUNT_BILL_STATUS.VIEW_LIST], icon: "mdi mdi-file-check-outline" },
]

const SetupTab = () => (
  <Card className="border-0 shadow-sm">
    <CardBody>
      <div className="mb-4">
        <h5 className="mb-1">Finance Setup</h5>
        <p className="text-muted mb-0 small">Keep configuration pages reachable from the workspace without mixing them into daily transaction work.</p>
      </div>
      <Row className="g-3">
        {setupLinks.map(item => (
          <CanView key={item.path} access={item.access}>
            <Col md={6} xl={3}>
              <Link to={item.path} className="text-decoration-none">
                <div className="border rounded-3 p-3 h-100">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <i className={`${item.icon} text-primary`} style={{ fontSize: 24 }} />
                    <i className="mdi mdi-chevron-right text-muted" />
                  </div>
                  <div className="fw-semibold text-dark">{item.label}</div>
                  <div className="text-muted small mt-1">Open the full setup page</div>
                </div>
              </Link>
            </Col>
          </CanView>
        ))}
      </Row>
    </CardBody>
  </Card>
)

export default SetupTab
